import Navbar from '../components/Navbar'
import BreadCrumb from '../components/BreadCrumb'
import Footer from '../components/Footer'
import GroomingPagePrice from '../components/GroomingPagePrice'
import GroomingPageFeature from '../components/GroomingPageFeature'
import GroomingPageAbout from '../components/GroomingPageAbout'

import { Helmet } from "react-helmet";
import ScrollNavbar from '../components/ScrollNavbar'
import CustomerFeedback from '../components/main/CustomerFeedback'


const PetGroomingPage = () => {
  return (
    <div>

<Helmet>
        <title>🐾 Premium Pet Grooming at Home | FluffyTouch</title>
        <meta
          name="description"
          content="
          Book expert at-home pet grooming for dogs & cats! Certified groomers, same-day slots & 30% OFF first booking. Stress-free care in your home. Call now!
        "
        />
      </Helmet>
      <ScrollNavbar/>


        <Navbar/>
        <BreadCrumb name="Pet Grooming" title="Best Pet Grooming Services At Home"/>
        <GroomingPageAbout/>
        <GroomingPagePrice/>
        <GroomingPageFeature/>

          <div   className='ft-customer-rev-of-get-grooming-page'>
        <CustomerFeedback  viewMoreValue="active" />
        </div>

        <Footer/>

        
    </div>
  )
}

export default PetGroomingPage